var loadMenu=function(router, typeAccount,idEnterprise)
{   
    console.log(typeAccount)
    console.log(idEnterprise)

    if(typeAccount===4){
        router.addRoutes([ {
            path:'/enterprise', 
            name:'Empresas',
            component: require('../view/enterprise/app.vue').default
        },
        {
            path:'/division', 
            name:'Divisiones',
            component: require('../view/division/app.vue').default
        },        
        ])
        
    }
    
    if(typeAccount===6){
        router.addRoutes([ 
            {
                path:'/reportUrl', 
                name:'Reportes',
                component: require('../view/reportUrl/app.vue').default
            }, 
            {
                path:'/division', 
                name:'Divisiones',
                component: require('../view/division/app.vue').default
            },
            {
                path:'/link', 
                name:'Link',
                component: require('../view/link/app.vue').default
            }])
    }
    else if(typeAccount===3 || typeAccount===2){
        router.addRoutes([ 
            {
                path:'/division', 
                name:'Divisiones',
                component: require('../view/division/app.vue').default
            },
            {
                path:'/reportUrl', 
                name:'Reportes',
                component: require('../view/reportUrl/app.vue').default
            },
            {
                path:'/resetPassword', 
                name:'Reset Password',
                component: require('../view/resetPassword/app.vue').default
            }, 
            {
                path:'/report', 
                name:'Reportes',
                component: require('../view/report/documentReport/app.vue').default
            } , 
            {
                path:'/non-conformingReportClosure', 
                name:'non-conformingReportClosure',
                component: require('../view/report/non-conformingReportClosure/app.vue').default
            }, 
            {
                path:'/non-conformingReportClosure', 
                name:'non-conformingReportClosure',
                component: require('../view/report/non-conformingReportClosure/app.vue').default
            }, 
            {
                path:'/nonConformitiesPending', 
                name:'nonConformitiesPending',
                component: require('../view/nonConformities/pending/app.vue').default
            },
            {
                path:'/nonConformitiesClosed', 
                name:'nonConformitiesClosed',
                component: require('../view/nonConformities/closed/app.vue').default
            },
            {
                path:'/link', 
                name:'Link',
                component: require('../view/link/app.vue').default
            } ])
    }
    else if(typeAccount===1 || typeAccount===4){   
        console.log("cargando rutas");
            router.addRoutes([
                                
                                {
                                    path:'/branchOffices', 
                                    name:'Oficinas',
                                    component: require('../view/branchOffices/app.vue').default
                                },
                                {
                                    path:'/expressionRegulate', 
                                    name:'Expresiones Regulares',
                                    component: require('../view/expressionRegulate/app.vue').default
                                },
                                {
                                    path:'/users', 
                                    name:'Usuarios',
                                    component: require('../view/users/app.vue').default
                                },
                                {
                                    path:'/division', 
                                    name:'Divisiones',
                                    component: require('../view/division/app.vue').default
                                },
                                {
                                    path:'/usersReport', 
                                    name:'Usuarios Report',
                                    component: require('../view/usersReport/app.vue').default
                                },
                                {
                                    path:'/profiles', 
                                    name:'Perfiles',
                                    component: require('../view/profiles/app.vue').default
                                },
                                {
                                    path:'/docType', 
                                    name:'Tipo Documentos',
                                    component: require('../view/docType/app.vue').default
                                },
                                {
                                    path:'/docCategory', 
                                    name:'Categorias Documento',
                                    component: require('../view/docCategory/app.vue').default
                                }, 
                                {
                                    path:'/docListSelect', 
                                    name:'Listas Desplegables',
                                    component: require('../view/docListSelect/app.vue').default
                                }, 
                                {
                                    path:'/docConfig', 
                                    name:'Configuracion Documento',
                                    component: require('../view/docConfig/app.vue').default
                                }, 
                                 {
                                     path:'/resetPassword', 
                                     name:'Reset Password',
                                     component: require('../view/resetPassword/app.vue').default
                                 }, 
                                {
                                    path:'/goalsso', 
                                    name:'Mantenedor Metas',
                                    component: require('../view/goalSSO/app.vue').default
                                },                                
                                {
                                    path:'/document', 
                                    name:'Documentos',
                                    component: require('../view/document/app.vue').default
                                }, 
                                {
                                    path:'/report', 
                                    name:'Reportes',
                                    component: require('../view/report/documentReport/app.vue').default
                                } , 
                                {
                                    path:'/non-conformingReportClosure', 
                                    name:'non-conformingReportClosure',
                                    component: require('../view/report/non-conformingReportClosure/app.vue').default
                                }, 
                                {
                                    path:'/non-conformingReportPending', 
                                    name:'non-conformingReportPending',
                                    component: require('../view/report/non-conformingReportPending/app.vue').default
                                },
                                {
                                    path:'/nonConformitiesPending', 
                                    name:'nonConformitiesPending',
                                    component: require('../view/nonConformities/pending/app.vue').default
                                },
                                {
                                    path:'/nonConformitiesClosed', 
                                    name:'nonConformitiesClosed',
                                    component: require('../view/nonConformities/closed/app.vue').default
                                },
                                {
                                    path:'/link', 
                                    name:'Link',
                                    component: require('../view/link/app.vue').default
                                },
                               
                            
                            ])
        }                    
}

export default {
    loadMenu
}